<template>
    <div class="col-md-3 mx-auto pt-5">
        <div class="bg-white rounded p-3 shadow">
            <div class="text-center">
                <img src="assets/images/logo.svg" class="img-fluid" alt="" width="220px">
            </div>
            <form v-if="!isOtpCode" novalidate class="mt-3 justify-content-center " @submit.prevent="userLogin" autocomplete="off" style="display: grid">
                <formControl label="Email"
                             type="text"
                             name="email"
                             v-model="email"
                             v-validate="'required|email'"
                             ref="email"
                             :error="errors.first('email')"
                />

                <formControl label="Password"
                             type="password"
                             name="password"
                             class="mb-3"
                             v-model="password"
                             v-validate="'required'"
                             :error="errors.first('password')"
                />
                <formButton text="Login" classes="btn-primary w-96 mb-2"/>
            </form>
            <form v-else novalidate class="mt-3 justify-content-center " @submit.prevent="userLoginCode" autocomplete="off" style="display: grid">
              <formControl label="Sms Code"
                           type="number"
                           name="otpCode"
                           v-model="otpCode"
                           v-validate="'required'"
                           ref="otpCode"
                           :error="errors.first('otpCode')"
              />
              <formButton text="Login" classes="btn-primary w-96 mb-2"/>
            </form>
        </div>
    </div>
</template>


<script>
  import axios from '../axios'
  import router from '../router'
  import formControl from '@/components/formcontrol'
  import formButton from '@/components/button'

  export default {
    name: 'Login',
    components: {
      formControl, formButton
    },

    mounted () {
      this.$refs.email.$el.getElementsByTagName('input')[0].focus()
    },

    data: function () {
      return {
        email: '',
        password: '',
        otpToken: '',
        isOtpCode: false,
        otpCode: '',
      }
    },

    methods: {

      userLogin () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            let user = {
              email: this.email,
              password: this.password,
            }

            axios.post('login', user)
              .then(res => {
                if(res.data.data.isOtpCode) {
                  this.isOtpCode = true
                  this.otpToken = res.data.data.otpToken
                  $('.form-control').addClass('focus')
                  this.$emit('alert', 'success', 'הקוד נשלח לנייד')
                }
                if(res.data.data.isnatanuser){
                  axios.defaults.headers.Authorization = 'Bearer ' + res.data.data.token
                  this.$store.dispatch('login', res.data.data)
                  let userFirstName = res.data.data.user.firstName
                  this.$emit('alert', 'success', 'Welcome back ' + userFirstName.charAt(0).toUpperCase() + userFirstName.slice(1))
                  router.replace('/')
                }

                // this.$store.dispatch('login', res.data.data)
                // let userFirstName = res.data.data.user.firstName
                // this.$emit('alert', 'success', 'Welcome back ' + userFirstName.charAt(0).toUpperCase() + userFirstName.slice(1))
                // router.replace('/')
              }).catch(err => {
              this.$emit('alert', 'danger', 'A problem accoured')
            })
          }
        })
      },
      userLoginCode () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            let user = {
              otpCode: this.otpCode,
              otpToken: this.otpToken,
            }

            axios.post('otpAuth', user)
              .then(res => {
                  if(res.data.data.error) {
                    this.$emit('alert', 'danger', 'הקוד אינו תואם או שפג תוקפו יש לנסות שנית')
                    return;
                  }

                  axios.defaults.headers.Authorization = 'Bearer ' + res.data.data.token
                  this.$store.dispatch('login', res.data.data)
                  let userFirstName = res.data.data.user.firstName
                  this.$emit('alert', 'success', 'Welcome back ' + userFirstName.charAt(0).toUpperCase() + userFirstName.slice(1))
                  router.replace('/')
                }).catch(err => {
              this.$emit('alert', 'danger', 'A problem accoured')
            })
          }
        })
      }
    },

  }

</script>
